import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Incoming: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 7.87158L7.81429 11.5716L13.6286 7.87158"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.81429 1V6.81429"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.7 4.7002L7.81428 6.81448L9.92857 4.7002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.58571 6.28564H3.05714C2.4733 6.28564 2 6.75895 2 7.34279V13.6856C2 14.2695 2.4733 14.7428 3.05714 14.7428H12.5714C13.1553 14.7428 13.6286 14.2695 13.6286 13.6856V7.34279C13.6286 6.75895 13.1553 6.28564 12.5714 6.28564H12.0429"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
